export default __webpack_public_path__ + "img/cPxHvsty.b38e019c.svg";